import { useEffect, useState } from "react";
import "./session-expired.css";

// The one thing in the app allowed to interrupt everything.
//
// A 401 means the work in front of the reader cannot be saved, so the
// alternative -- letting them keep typing into a form that will fail --
// is worse than a modal. Nothing dismisses it except signing in again:
// there is no "carry on" state to return to.
//
// Raised by the axios response interceptor, which fires
// SESSION_EXPIRED_EVENT once per expiry.
//
// Drawn as the house popup (head / body / foot, the palette's accent on
// the button) -- see session-expired.css for what it used to be and why
// that stopped being right once palettes shipped.
export const SESSION_EXPIRED_EVENT = "lms:session-expired";

const SessionExpired = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onExpired = () => setOpen(true);
    window.addEventListener(SESSION_EXPIRED_EVENT, onExpired);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, onExpired);
  }, []);

  // While it is up, nothing behind it should scroll.
  useEffect(() => {
    if (!open) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [open]);

  if (!open) return null;

  const signIn = () => {
    try {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("googleAccessToken");
    } catch {
      // A browser with storage blocked still gets to the sign-in page.
    }
    window.location.href = "/login";
  };

  return (
    <div className="sx" role="alertdialog" aria-modal="true" aria-labelledby="sx-title" aria-describedby="sx-text">
      <div className="sx-card">
        <header className="sx-head">
          <span className="sx-eyebrow">Signed out</span>
          <h2 className="sx-title" id="sx-title">
            Your session has ended
          </h2>
        </header>

        <div className="sx-body">
          <p className="sx-text" id="sx-text">
            You have been signed out for security. Sign in again to pick up
            where you left off.
          </p>
          <p className="sx-note">Anything unsaved on this page will be lost.</p>
        </div>

        <footer className="sx-foot">
          <button type="button" className="sx-btn" onClick={signIn} autoFocus>
            Sign in again
          </button>
        </footer>
      </div>
    </div>
  );
};

export default SessionExpired;
